import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';
import { TokenService } from '../../service/token.service';

const PUBLIC_API_PATTERNS: string[] = [
  'api/1.0/login/userLoginAsync',
  'api/1.0/register/createNewUserAsync',
  '/api/1.0/OTPSender/sendOTPUserAsync',
  '/api/1.0/enum/getTextServiceTypeAsync',
  '/api/1.0/enum/getCountryInfoAsync',
  '/api/1.0/login/forgetPasswordSendOtpAsync',
  '/api/1.0/login/forgetPasswordAsync',
  '/api/1.0/subscription/updateSubscriptionAsync',
  '/api/1.0/group/GetRegisterConfigInfoAsync',
  '/api/1.0/enum/getPackageInfoAsync',
  '/api/1.0/enum/getCoupenTypeAsync',
  '/api/1.0/auth/verifyMobileNoAsync',
  '/api/1.0/auth/resetPasswordWithMobieNoAsync',
  '/api/1.0/auth/refreshTokenAsync',
];

const API_KEY = 'gV7Zk8mA4BxR2pWNhTdY5JqOEX13sCHvKnDI0ctSGabjF6lruwQzxnT';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const dialog = inject(MatDialog);
  const tokenService = inject(TokenService);

  const isPublicApi = PUBLIC_API_PATTERNS.some((pattern) =>
    req.url.includes(pattern)
  );

  let modifiedReq = req;

  if (isPublicApi) {
    modifiedReq = req.clone({
      setHeaders: {
        'Api-Key': API_KEY,
      },
    });
  } else {
    const token = localStorage.getItem('token');
    if (token) {
      modifiedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
  }

  return next(modifiedReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !isPublicApi) {
        return tokenService.refreshToken().pipe(
          switchMap((newToken) => {
            const retryReq = req.clone({
              setHeaders: {
                Authorization: `Bearer ${newToken}`,
              },
            });
            return next(retryReq);
          }),
          catchError((refreshError) => {
            localStorage.clear();
            sessionStorage.clear();
            dialog.closeAll();
            return throwError(() => refreshError);
          })
        );
      }
      return throwError(() => error);
    })
  );
};
